/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { FormAction } from "../../types/enums";

/**
 * State of the group slice: the group currently being viewed or edited,
 * the active selection, and the open/closed flags for this area's modals.
 */
export interface GroupState {
  group: any;
  openDrawer: boolean;
  openForm: boolean;
  refreshTable: boolean;
  formAction: FormAction;
  openModalDelete: boolean;
}

const initialState: GroupState = {
  group: {},
  openDrawer: false,
  openForm: false,
  refreshTable: false,
  formAction: FormAction.Create,
  openModalDelete: false,
};

export const groupSlice = createSlice({
  name: "group",
  initialState,
  reducers: {
    updateGroup: (state, action: PayloadAction<any>) => {
      state.group = action.payload;
    },
    updateOpenDrawer: (state, action: PayloadAction<boolean>) => {
      state.openDrawer = action.payload;
    },
    updateOpenForm: (state, action: PayloadAction<boolean>) => {
      state.openForm = action.payload;
    },
    updateRefreshTable: (state, action: PayloadAction<boolean>) => {
      state.refreshTable = action.payload;
    },
    updateFormAction: (state, action: PayloadAction<FormAction>) => {
      state.formAction = action.payload;
    },
    updateOpenModalDelete: (state, action: PayloadAction<boolean>) => {
      state.openModalDelete = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateGroup,
  updateOpenDrawer,
  updateOpenForm,
  updateRefreshTable,
  updateFormAction,
  updateOpenModalDelete,
} = groupSlice.actions;

export default groupSlice.reducer;
